import './App.css';
import Header from './components/Header';
import Cards from './components/Cards';
import Heroimg from './components/Heroimg';
import Footer from './components/Footer';

function App() {
	return (
		<div>
			<Header />
			<Heroimg />
			<Cards />
			<Footer />
		</div>
	);
}

export default App;
